/* @flow */
import AlertDialog from 'components/AlertDialog';
import React from 'react';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities';

type Props = {
  onOkay: Function,
  onRequestHide: Function,
};

class StudentsParentsDialog extends React.Component<Props> {
  render() {
    const subtextText = `Create a class to stay connected with your clubs, teams, organizations, and
      more! 🎉`;
    const subtext = (
      <TextWithEntities text={subtextText} entities={TextEntities.parseEmoji(subtextText)} />
    );
    return (
      <AlertDialog
        eventScreenName="StudentsParentsDialog"
        title="Want to reach a group with Remind?"
        subtext={subtext}
        buttonText="Create a class"
        onOkay={this.props.onOkay}
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}
export default StudentsParentsDialog;
